import { useSelector } from 'react-redux';
import { useRoleObject } from '../../pages/arc/components/useRoles';
import { DiocesanAdministrator, SeniorGroupPlanAdmin, SeniorOfficer } from '../../pages/arc/constants/constant-strings';
import { TcsmStates } from '../../root/tcsm-model';
import { roleMapping, RoleObject } from '../models/authenticated-model';
import { NavLink } from '../models/navigation-model';

export function roleObjectMatch(rolesMatch: string, roles: RoleObject) {
	if (!rolesMatch || !roles) return 1;

	let numberOfMatches = 0;
	const rolesMatches = rolesMatch.split(',');
	for (let x = 0; x < rolesMatches.length; x += 1) {

		const rolesProperties = rolesMatches[x]?.trim().split('.');

		if (roles[roleMapping[rolesProperties[0]] || rolesProperties[0]]?.map(r => r?.role_name).includes(rolesProperties[1]))
			numberOfMatches += 1;
	}

	// add 1 if there is at least 1 match, so that 1 matched role will take precedence over an item with no rolesMatch
	return numberOfMatches > 0 ? numberOfMatches + 1 : 0;

}
// returns number of matches in the roles matrix compared to the passed in role
export function roleMatches(rolesMatch: string, roles: any): number {
	if (!rolesMatch) return 1;

	let numberOfMatches = 0;
	const rolesMatches = rolesMatch.split(',');
	for (let x = 0; x < rolesMatches.length; x += 1) {

		const rolesProperties = rolesMatches[x].split('.');

		let propertyMatch = roles;
		for (let z = 0; z < rolesProperties.length; z += 1) {
			if (!propertyMatch) break;

			propertyMatch = propertyMatch[rolesProperties[z].trim()];
		}

		if (propertyMatch) {
			numberOfMatches += 1;
		}
	}

	// add 1 if there is at least 1 match, so that 1 matched role will take precedence over an item with no rolesMatch
	return numberOfMatches > 0 ? numberOfMatches + 1 : 0;
}

export function getLinksByRoles(links: NavLink[], roles: any) {

	const allowedLinks = [];

	for (let i = 0; i < links?.length; i += 1) {
		const link = links[i];

		if (roleObjectMatch(link.RolesMatch, roles) > 0) {
			allowedLinks.push(link);
		}
	}

	return allowedLinks;
}


export function isDioAdmin(cn?: string) {
	const roles = useRoleObject();
	const allRoles = useSelector<TcsmStates, string[]>(state => state?.authenticatedState.roles);
	if (cn) {
		return roles?.institution_roster?.find(a => a.role_name === DiocesanAdministrator && a.role_target === cn);
	}

	return allRoles?.includes(DiocesanAdministrator);
}

export function isInstitutionOfficer() {
	const allRoles = useSelector<TcsmStates, string[]>(state => state?.authenticatedState.roles);
	return allRoles?.includes(SeniorOfficer);
}

export function isInstitutionOfficerOnly() {
	const allRoles = useSelector<TcsmStates, string[]>(state => state?.authenticatedState.roles);
	const requireApproval = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.enrollmentOptions?.require_approval);
	return requireApproval || (allRoles?.includes(SeniorOfficer) && !allRoles?.includes(DiocesanAdministrator) && !allRoles?.includes(SeniorGroupPlanAdmin));

}

export function setCookie(name, value, days) {
	let expires = '';
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}
	document.cookie = `${name}='${value || ''}'${expires}; path=/`;
}